import React from 'react';
import * as FaIcons from 'react-icons/fa';
import * as AiIcons from 'react-icons/ai';
import * as IoIcons from 'react-icons/io';
import * as VscIcons from 'react-icons/vsc';
import * as IconName from "react-icons/bi";

export const SidebarData = [
    {
        title: 'Accueil',
        path: '/',
        icon: <AiIcons.AiFillHome/>,
        cName: 'nav-text'
    },
    {
        title: 'Journal d\'appels',
        path: '/journal-appels',
        icon: <IoIcons.IoIosPaper/>,
        cName: 'nav-text'
    },
    {
        title: 'Liste noire',
        path: '/liste-noire',
        icon: <FaIcons.FaRegListAlt/>,
        cName: 'nav-text'
    },
    {
        title: 'Liste blanche',
        path: '/liste-blanche',
        icon: <FaIcons.FaRegListAlt/>,
        cName: 'nav-text'
    },
    {
        title: 'Réglages',
        path: '/reglages',
        icon: <VscIcons.VscSettingsGear/>,
        cName: 'nav-text'
    },
    {
        title: 'Nous contacter',
        path: '/contacts',
        icon: <IconName.BiPhone/>,
        cName: 'nav-text'
    },
    // {
    //     title: 'Support',
    //     path: '/support',
    //     icon: <IoIcons.IoMdHelpCircle/>,
    //     cName: 'nav-text'
    // }
];